import RestService from "../services/rest.service";

export const getOrganization = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/kpi/users/organization`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};
